<arivo-alerts></arivo-alerts>

<div class="headline-small mb-2 md:mb-4" [innerText]="'Vehicles.VehiclesContracts' | translate"></div>

@if (vehicles.length > 0) {
  <!-- Mobile -->
  <div class="flex xl:hidden flex-col gap-2">
    @for (vehicle of vehicles; track vehicle) {
      <arivo-accordion class="border-gray-200 border-1">
        <arivo-accordion-header [caretLeft]="true">
          <div class="flex items-center justify-between gap-4">
            <arivo-license-plate [country]="vehicle.license_plate_country" [licensePlate]="vehicle.license_plate" />
            @if (vehicle.garage_contracts.length > 0) {
              <button
                type="button"
                class="vehicle-action text-neutral-50"
                (click)="$event.stopPropagation()"
                [matTooltip]="'Vehicles.RemoveContractsBeforeDeletingVehicle' | translate"
                [attr.aria-label]="'Vehicles.RemoveContractsBeforeDeletingVehicle' | translate"
              >
                <i class="text-lg fa-kit fa-delete"></i>
              </button>
            } @else {
              <button
                type="button"
                class="vehicle-action text-error"
                (click)="openDeleteVehicleDialog($event, vehicle)"
                [attr.aria-label]="'Common.Delete' | translate"
              >
                <i class="text-lg fa-kit fa-delete"></i>
              </button>
            }
          </div>
        </arivo-accordion-header>
        <arivo-accordion-body>
          @if (vehicle.pay_per_use_enabled || !showShortTermParking || vehicle.garage_contracts.length > 0) {
            @if (showShortTermParking) {
              <div class="flex items-center justify-between">
                <div class="body-medium">
                  <span class="font-medium text-decoration-dark" [innerText]="'Vehicles.ShortTermParking' | translate"></span>
                </div>
                <div class="body-medium">
                  @if (vehicle.pay_per_use_enabled) {
                    <span class="text-decoration-dark" [innerText]="'Common.Allowed' | translate"></span>
                  } @else {
                    <span class="text-decoration-dark" [innerText]="'Common.Not allowed' | translate"></span>
                  }
                </div>
              </div>
              <hr class="my-4" />
            }
            <div class="body-medium mb-2">
              <span class="font-medium text-decoration-dark" [innerText]="'Vehicles.Contracts' | translate"></span>
            </div>

            @if (vehicle.garage_contracts.length > 0) {
              <div class="flex flex-col gap-2">
                @for (contract of vehicle.garage_contracts; track contract) {
                  <div
                    class="cursor-pointer bg-surface-70 rounded"
                    (click)="sendContractEditOpenedEventToAmplitude()"
                    [routerLink]="['/contracts/edit', contract.id]"
                  >
                    <div class="flex items-center gap-4 px-4 py-2">
                      <div class="text-3xl text-success-dark">
                        <i class="fa-kit fa-parking"></i>
                      </div>
                      <div class="flex-grow">
                        @if (contract.garage?.name) {
                          <div class="body-large" [innerText]="contract.garage!.name"></div>
                        } @else {
                          <div class="body-large" [innerText]="contract.name"></div>
                        }
                        <div class="body-small">
                          <span class="text-neutral-50">
                            <span [innerText]="contract.name"></span>
                            <span>, </span>
                            <span [innerText]="'Contracts.ParkingSpaces' | translatePlural: { count: contract.group_limit }"></span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            } @else {
              <div class="body-medium">
                <span class="text-neutral-50" [innerText]="'Vehicles.NoContracts' | translate"></span>
              </div>
            }
          } @else {
            <div class="bg-error-transparent-8 flex items-center gap-4 rounded p-4">
              <div class="flex-shrink flex">
                <i class="text-error fa-light fa-triangle-exclamation"></i>
              </div>
              <div class="flex-1 body-medium" [innerText]="'Vehicles.VehicleCannotBeUsed' | translate"></div>
            </div>
          }
          <hr class="my-4" />
          <div class="body-medium mb-2 flex items-center justify-between gap-4">
            <span class="font-medium text-decoration-dark" [innerText]="'Vehicles.Description' | translate"></span>
            <button
              type="button"
              class="vehicle-action text-interaction-dark"
              (click)="openVehicleDescriptionDialog($event, vehicle)"
              [matTooltip]="'Vehicles.EditDescription' | translate"
              [attr.aria-label]="'Vehicles.EditDescription' | translate"
            >
              <i class="vehicle-action-icon-notebook text-lg fa-light fa-note-sticky"></i>
            </button>
          </div>
          <div class="body-medium">
            @if (vehicle.description) {
              <span class="text-decoration-dark break-words" [innerText]="vehicle.description"></span>
            } @else {
              <span class="text-neutral-50" [innerText]="'Vehicles.NoDescription' | translate"></span>
            }
          </div>
        </arivo-accordion-body>
      </arivo-accordion>
    }
  </div>

  <!-- Desktop -->
  <div class="card hidden xl:block">
    <div class="card-body">
      <table class="table-primary">
        <thead>
          <tr>
            <th class="body-medium">
              <span class="font-medium" [innerText]="'Vehicles.Vehicle' | translate"></span>
            </th>
            @if (showShortTermParking) {
              <th class="body-medium">
                <span class="font-medium" [innerText]="'Vehicles.ShortTermParking' | translate"></span>
              </th>
            }
            <th class="body-medium">
              <span class="font-medium" [innerText]="'Vehicles.Contracts' | translate"></span>
            </th>
            <th class="body-medium">
              <span class="font-medium" [innerText]="'Vehicles.Description' | translate"></span>
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (vehicle of vehicles; track vehicle) {
            <tr>
              <td>
                <arivo-license-plate [country]="vehicle.license_plate_country" [licensePlate]="vehicle.license_plate" />
              </td>
              @if (vehicle.pay_per_use_enabled || !showShortTermParking || vehicle.garage_contracts.length > 0) {
                @if (showShortTermParking) {
                  <td>
                    <div class="body-medium">
                      @if (vehicle.pay_per_use_enabled) {
                        <span class="text-decoration-dark" [innerText]="'Common.Allowed' | translate"></span>
                      } @else {
                        <span class="text-decoration-dark" [innerText]="'Common.Not allowed' | translate"></span>
                      }
                    </div>
                  </td>
                }
                <td>
                  @if (vehicle.garage_contracts.length > 0) {
                    <div class="inline-flex flex-col gap-2">
                      @for (contract of vehicle.garage_contracts; track contract) {
                        <div
                          class="flex items-center gap-2 cursor-pointer bg-surface-70 rounded px-4 py-2"
                          [routerLink]="['/contracts/edit', contract.id]"
                        >
                          <div class="text-3xl text-success-dark">
                            <i class="fa-kit fa-parking"></i>
                          </div>
                          <div class="flex-grow">
                            @if (contract.garage?.name) {
                              <div class="body-large" [innerText]="contract.garage!.name"></div>
                            } @else {
                              <div class="body-large" [innerText]="contract.name"></div>
                            }
                            <div class="body-small">
                              <span class="text-neutral-50">
                                <span [innerText]="contract.name"></span>
                                <span>, </span>
                                <span [innerText]="'Contracts.ParkingSpaces' | translatePlural: { count: contract.group_limit }"></span>
                              </span>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  } @else {
                    <div class="body-medium">
                      <span class="text-neutral-50" [innerText]="'Vehicles.NoContracts' | translate"></span>
                    </div>
                  }
                </td>
              } @else {
                @if (showShortTermParking) {
                  <td colspan="2">
                    <div class="flex items-center gap-2">
                      <div class="flex-shrink flex">
                        <i class="text-error fa-light fa-triangle-exclamation"></i>
                      </div>
                      <div class="flex-1 body-medium">
                        <span class="text-error" [innerText]="'Vehicles.VehicleCannotBeUsed' | translate"></span>
                      </div>
                    </div>
                  </td>
                } @else {
                  <td colspan="1">
                    <div class="flex items-center gap-2">
                      <div class="flex-shrink flex">
                        <i class="text-error fa-light fa-triangle-exclamation"></i>
                      </div>
                      <div class="flex-1 body-medium">
                        <span class="text-error" [innerText]="'Vehicles.NoContracts' | translate"></span>
                      </div>
                    </div>
                  </td>
                }
              }
              <td class="body-medium w-1/4 max-w-0">
                @if (vehicle.description) {
                  <span class="w-full text-decoration-dark break-words" [innerText]="vehicle.description"></span>
                } @else {
                  <span class="text-neutral-50" [innerText]="'Vehicles.NoDescription' | translate"></span>
                }
              </td>
              <td class="w-min whitespace-nowrap">
                <div class="flex items-center justify-end gap-3 whitespace-nowrap">
                  <button
                    type="button"
                    class="vehicle-action text-interaction-dark"
                    (click)="openVehicleDescriptionDialog($event, vehicle)"
                    [matTooltip]="'Vehicles.EditDescription' | translate"
                    [attr.aria-label]="'Vehicles.EditDescription' | translate"
                  >
                    <i class="vehicle-action-icon-notebook text-lg fa-light fa-note-sticky"></i>
                  </button>
                  @if (vehicle.garage_contracts.length > 0) {
                    <button
                      type="button"
                      class="vehicle-action text-neutral-50"
                      (click)="$event.stopPropagation()"
                      [matTooltip]="'Vehicles.RemoveContractsBeforeDeletingVehicle' | translate"
                      [attr.aria-label]="'Vehicles.RemoveContractsBeforeDeletingVehicle' | translate"
                    >
                      <i class="text-lg fa-kit fa-delete"></i>
                    </button>
                  } @else {
                    <button
                      type="button"
                      class="vehicle-action text-error"
                      (click)="openDeleteVehicleDialog($event, vehicle)"
                      [attr.aria-label]="'Common.Delete' | translate"
                    >
                      <i class="text-lg fa-kit fa-delete"></i>
                    </button>
                  }
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <arivo-dialog #deleteVehicleDialog>
    <div class="card card-small p-2">
      <div class="card-body">
        <div class="body-medium mb-4" [innerHtml]="'Vehicles.DeleteVehicle' | translate"></div>
        <div class="flex items-center justify-end gap-2">
          <button
            class="button-primary-text button-small"
            (click)="closeDeleteVehicleDialog()"
            [innerText]="'Common.Cancel' | translate"
          ></button>
          <button class="button-danger button-small" (click)="deleteVehicle()" [innerText]="'Common.Delete' | translate"></button>
        </div>
      </div>
    </div>
  </arivo-dialog>

  <arivo-dialog #vehicleDescriptionDialog [dismissible]="false">
    <div class="card card-small p-2">
      <div class="card-body">
        <div class="body-large font-medium mb-4" [innerText]="'Vehicles.EditDescription' | translate"></div>
        @if (descriptionVehicleItem) {
          <div class="mb-4">
            <arivo-license-plate
              [country]="descriptionVehicleItem.license_plate_country"
              [licensePlate]="descriptionVehicleItem.license_plate"
            />
          </div>
        }
        <div class="input-primary-container mb-4">
          <label for="vehicleDescription" class="sr-only">{{ 'Vehicles.Description' | translate }}</label>
          <textarea
            id="vehicleDescription"
            class="input-primary vehicle-description-input"
            maxlength="500"
            rows="5"
            [(ngModel)]="vehicleDescription"
            [placeholder]="'Vehicles.DescriptionPlaceholder' | translate"
          ></textarea>
          <div class="body-small text-neutral-50 text-right mt-1">{{ vehicleDescription.length }}/500</div>
        </div>
        <div class="flex items-center justify-end gap-2">
          <button
            class="button-primary-text button-small"
            (click)="closeVehicleDescriptionDialog()"
            [innerText]="'Common.Cancel' | translate"
          ></button>
          <button class="button-primary button-small" (click)="saveVehicleDescription()" [innerText]="'Common.Save' | translate"></button>
        </div>
      </div>
    </div>
  </arivo-dialog>
} @else {
  <div class="text-center my-6">
    <div class="text-neutral-50 text-2xl">
      <i class="fa-kit fa-vehicles"></i>
    </div>
    <div class="body-medium mt-2">
      <span class="text-neutral-50" [innerText]="'Vehicles.NoVehicles' | translate"></span>
    </div>
  </div>
}
